import { render, staticRenderFns } from "./settings-expenses-types.vue?vue&type=template&id=919d074e"
import script from "./settings-expenses-types.vue?vue&type=script&lang=js"
export * from "./settings-expenses-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports